import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-eula',
    templateUrl: './eula.component.html',
    styleUrls: ['./eula.component.scss'],
    standalone: false,
})
export class EulaComponent implements OnInit {
    acceptEula: () => void;

    constructor(private dialog: MatDialog) {}

    closeBtnAction = () => {
        this.dialog.closeAll();
    };

    ngOnInit() {}
}
